import { NgModule, Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
// import { BsDatepickerModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

// import { MaterialModule, MdDatepickerModule, MdNativeDateModule } from '@angular/material';
// import { BrowserModule } from '@angular/platform-browser';
// import { NgDatepickerModule } from 'ng2-datepicker';


// BsDatepickerModule.forRoot();

declare var jQuery: any;
declare var Material: any;

@NgModule({
 	imports: [		
 		BsDatepickerModule.forRoot()
 	  ],
 })

@Component({
	selector: 'app-profile-verification-report-list',
	templateUrl: './profile-verification-report-list.component.html',
	styleUrls: ['./profile-verification-report-list.component.css']
})


export class ProfileVerificationReportListComponent implements OnInit {

	// minDate = new Date(2017, 5, 10);
	// maxDate = new Date(2018, 9, 15);

	// myForm = new FormGroup({
	// myDateYMD: new FormControl(new Date()),
	// myDateFull: new FormControl(new Date()),
	// myDateMDY: new FormControl(new Date())
	// });

	bsValue = new Date();
	bsRangeValue: Date[];
	maxDate = new Date();
	common_api_url:string;

	
	

	surveyForm: any;
	ProfileVerificationReportList:any;
	//surveyActivityReportList: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	base64textString: any;
	attached_image: any;
	flashMsg: string;
	selectedSurveyData: any;
	selectedSurveyId: any;
	surveyTypeList: any;
	surveyExpiryList: any;
	surveyCategoryList: any;
	url: any;
	surveyType: any;
	isAproveProfileVerification: boolean;
	deleteSelectedSurveyData: any;
	approveSelectedProfileData:any;
	searchStr: any = "";
	surveyCategory: any = "";
	surveyStatus: any = "";
	isSurveyAvailable:boolean=false;
	redirectUrl:any;
	activePageNo:number=0;

// 	bsValue = new Date();
//   bsRangeValue: Date[];
//   maxDate = new Date();

	
    
   

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService, private cookieService: CookieService) { 

			this.maxDate.setDate(this.maxDate.getDate() + 7);
	  		this.bsRangeValue = [this.bsValue, this.maxDate];
			// this.maxDate.setDate(this.maxDate.getDate() + 7);
			// this.bsRangeValue = [this.bsValue, this.maxDate];
		}
		  
	ngOnInit() {
		
		this.initialiseSurvey();
		this.commonService.process();


		// $('.datepicker').datepicker();

		
		// setTimeout(() => {
		// 	//Material.loadWizard(false);
		// 	//Material.wizardLoad();
		// 	Material.setDatePicker('fromDate');
		//   }, 100);
	
	}

	// Get Survey List
	initialiseSurvey = function () {
		
		this.commonService.setTitle();
		this.limit = 10;
		this.pageNo = 1;
		this.url = '';
		this.surveyStatus = 0;
		//this.surveyTypeList = JSON.parse(this.cookieService.get('surveyTypeList'));

		// Get survey expiry date
		this.authService.getSurveyExpiryList().subscribe(data => {
			if (data.success) {
				this.surveyExpiryList = data.time;
			}
		});

		let route = this.router.url;
		if(route.indexOf("?") !== -1){
			var routeArr = route.split('?backUrl=');
			var decodedUri = decodeURIComponent(routeArr[1]);
			var decodedArr = decodedUri.split("&");
			var decodedPageNo =  decodedArr[0].split("pageNo=");
			this.pageNo = decodedPageNo[1];
			this.activePageNo = decodedPageNo[1];

			var decodedSurveyCategory = decodedArr[1].split("categoryId=");
			this.surveyCategory = decodedSurveyCategory[1];

			var decodedSurveyStatus = decodedArr[2].split("surveyStatus=");
			this.surveyStatus = decodedSurveyStatus[1];

			var decodedSearchStr = decodedArr[3].split("searchStr=");
			this.searchStr = decodedSearchStr[1];

			var decodedUrl = decodedArr[4].split("surveyTypeId=");
			this.url = decodedUrl[1];

			if(this.url == "5a66e31e85cfcd3f9289197c"){
				$(".navbar-brand").text("Profile Verification Report");
			}
			else if(this.url == "5a66e31e85cfcd3f9289197c"){
				$(".navbar-brand").text("Profile Verification Report");
			}
			else{
				$(".navbar-brand").text("Profile Verification Report");
			}
		}
		 if (route == "/profile-verification-report-list") {
			this.url = '';
			$(".navbar-brand").text("Profile Verification Report");
		}
		 if (route == "/country-profile-verification-report-list") {
			this.url = "5a66e31e85cfcd3f9289197c";
			$(".navbar-brand").text("Profile Verification Report");
		}
		 if (route == "/world-profile-verification-report-list") {
			this.url = "5a66e31385cfcd3f9289197b";
			$(".navbar-brand").text("Profile Verification Report");
		}

		// // Get survey category list
		this.authService.getSurveyCategoryList().subscribe(data => {
			if (data.success) {
				var that = this;
				this.surveyCategoryList = data.category;
				setTimeout(function(){ 
					$("#surveyCategory").val(that.surveyCategory);
					$("#surveyStatus").val(that.surveyStatus);
					$("#search").val(that.searchStr);
					$('#page_'+that.activePageNo).addClass('active');
					if(that.activePageNo == 1)
						$('#first, #prev').addClass('disabled');
					else if(that.activePageNo == that.pager.totalPages)
						$('#next, #last').addClass('disabled');
				},300);
			}
		});

		// Get survey list
		this.getProfileVerificationReportList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);

		this.surveyForm = new FormGroup({
			question: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(100),
				Validators.minLength(10),
			])),

			option_1: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])),

			option_2: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])),

			option_3: new FormControl("", Validators.maxLength(50)),

			option_4: new FormControl("", Validators.maxLength(50)),

			option_5: new FormControl("", Validators.maxLength(50)),

			survey_type_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			survey_expired_time: new FormControl("", Validators.compose([
				Validators.required
			])),

			survey_category_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			tags: new FormControl("", Validators.compose([
				// Validators.required
			])),
		});
	}

	// Get survey list
	getProfileVerificationReportList = function (pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {
		
		this.commonService.process();
		this.authService.getProfileVerificationReportList(pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr).subscribe(data => {
			
			if (data.success) {
				
				this.isSurveyAvailable = false;
				//this.ProfileVerificationReportList = data.result;
				this.ProfileVerificationReportList = data.user.docs;
				this.total = data.user.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = "pageNo="+pageNo+"&categoryId="+categoryId+"&surveyStatus="+surveyStatus+"&searchStr="+searchStr+"&surveyTypeId="+surveyTypeId;
			}
			else{
				
				this.ProfileVerificationReportList = [];
				this.isSurveyAvailable = true;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		//$('.pages').removeClass('active')
		$('.pages.active a').each(function(){
			if(parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.ProfileVerificationReportList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getProfileVerificationReportList(page, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
		}
	}

	// Update user functionality.
	updateSelectedSurvey = function (selectedSurveyData) {
		this.surveyForm.reset();
		this.selectedSurveyId = selectedSurveyData._id;
		// Set controls
		this.surveyForm.controls['question'].setValue(selectedSurveyData.question);
		if (selectedSurveyData.option.length > 0) {
			selectedSurveyData.option.forEach((item, index) => {
				this.surveyForm.controls['option_' + (index + 1)].setValue(selectedSurveyData.option[index].slice(0, -1));
			});
		}
		this.surveyForm.controls['survey_type_id'].setValue(selectedSurveyData.survey_type_id._id);
		this.surveyForm.controls['survey_category_id'].setValue(selectedSurveyData.survey_category_id._id);
		this.surveyForm.controls['survey_expired_time'].setValue(selectedSurveyData.survey_expired_time._id);
		this.surveyForm.controls['tags'].setValue(selectedSurveyData.tags);
	}

	onSubmit = function (data) {
		if (!this.surveyForm.valid) {
			this.validationService.validateAllFormFields(this.surveyForm);
			return;
		}

		this.options = [[data.option_1, "0"], [data.option_2, "0"]];
		if (data.option_3) {
			this.options.push([data.option_3, "0"]);
		}
		if (data.option_4) {
			this.options.push([data.option_4, "0"]);
		}
		if (data.option_5) {
			this.options.push([data.option_5, "0"]);
		}
		data.option = this.options;
		data.attached_image = this.attached_image;
		delete data.option_1;
		delete data.option_2;
		delete data.option_3;
		delete data.option_4;
		delete data.option_5;

		data.expiry_time = new Date();
		if (data.survey_expired_time == '5a66e3d285cfcd3f9289197d') {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 1);
		}
		else if (data.survey_expired_time == '5a66e3dd85cfcd3f9289197e') {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 7);
		}
		else {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 30);
		}
		this.authService.updateSurvey(data, this.selectedSurveyId).subscribe(res => {
			if (res.success) {
				data._id = this.selectedSurveyId;
				this.authService.cancelProcess();
				this.getProfileVerificationReportList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: res.message });
			}
			else {
				jQuery.growl.error({ title: 'Error', message: res.error });
			}
		});
	}

	// Delete selected Survey Details
	deleteSelectedSurveyComment = function (survey) {
		
		this.isAproveProfileVerification = true;
		this.deleteSelectedSurveyData = survey
	}

	// Delete Survey
	deleteSurvey = function (id) {
		
		this.authService.deleteSurveyActivityReport(id).subscribe(data => {
			if (data.success) {
				
				this.authService.cancelProcess();
				this.getProfileVerificationReportList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Upload Survey image functionality
	handleFiles = function (fileInput: Event) {
		this.imageArr = ['image/jpeg', 'image/jpg', 'image/png'];
		if (fileInput.target['files'][0]['size'] > 500000) {
			jQuery.growl.error({ title: 'Error', message: "File can not be larger than 0.5 MB" });
			return;
		}
		if (!this.imageArr.includes(fileInput.target['files'][0]['type'])) {
			jQuery.growl.error({ title: 'Error', message: "Invalid file format." });
			return;
		}
		var reader = new FileReader();
		reader.onload = this._handleReaderLoaded.bind(this);
		reader.readAsBinaryString(fileInput.target['files'][0]);
	}

	_handleReaderLoaded(readerEvt) {
		var binaryString = readerEvt.target.result;
		this.base64textString = btoa(binaryString);
		this.attached_image = 'data:image/jpeg;base64,' + this.base64textString;
		if (this.attached_image) {
			this.flashMsg = "Image uploaded successfully!";
		}
	}

	// Update survey status .
	updateSurveyStatus = function (surveyId) {
		this.authService.updateSurveyStatus(surveyId).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				$('#chk_' + surveyId).click();
				$('#chk_' + surveyId).is(':checked') ? $('#chk_' + surveyId).next('span.toggler').removeClass('off') : $('#chk_' + surveyId).next('span.toggler').addClass('off')
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Search survey
	searchProfileVerification = function () {
		
		// this.searchStr = $("#search").val();
		// this.surveyCategory = $("#surveyCategory").val();
		// this.surveyStatus = $("#surveyStatus").val();

		// var dt = $("#fromDate").val().split('-');
		// var dt1 = $("#toDate").val().split('-');
		var dt = $("#fromDate").val();//.split('-');
		var dt1 = $("#toDate").val();//.split('-');

if(dt>dt1)
{
		jQuery.growl.error({ title: 'Error', message: "Please Enter Valid Date!" });
return;
}
else
{
	//jQuery.growl.error({ title: 'Error', message: "Please Enter Valid Date!" });
}
        // var fromdate = new Date(dt[2], "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dt[1]) / 3, dt[0]);
		// var toDate =  new Date(dt1[2], "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dt1[1]) / 3, dt1[0]);
		var fromdate = dt//new Date(dt[2], "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dt[0]) / 3, dt[1]);
        var toDate = dt1 //new Date(dt1[2], "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dt1[0]) / 3, dt1[1]);
	//	this.getFilteredProfileVerificationReportList(1, this.limit, dt, dt1);
	 this.getFilteredProfileVerificationReportList(1, this.limit, fromdate, toDate);
	}

	// Get survey list
	getFilteredProfileVerificationReportList = function (pageNo, limit, fromdate, todate) {
		
		this.commonService.process();
		this.authService.getFilteredProfileVerificationReportList(pageNo, limit, fromdate, todate).subscribe(data => {
		
			if (data.success) {
				
				this.isSurveyAvailable = false;
				//this.ProfileVerificationReportList = data.result;
				this.ProfileVerificationReportList = data.user.docs;
				this.total = data.user.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = "pageNo="+pageNo+"&fromdate="+fromdate+"&todate="+todate;
			}
			else{
				
				this.ProfileVerificationReportList = [];
				this.isSurveyAvailable = true;
			}
			this.commonService.hideProcess();
		});
	}






	// approve selected profile Details
	approveSelectedProfileVerification = function (survey) {
		
		this.isAproveProfileVerification = true;
		this.approveSelectedProfileData = survey
	}

	// approve profile
	approveProfileVerificationData = function (id) {
		
		this.authService.approveProfileVerification(id).subscribe(data => {
			if (data.success) {
				
				this.authService.cancelProcess();
				this.getProfileVerificationReportList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}


	// reject selected profile Details
	rejectSelectedProfileVerification = function (survey) {
		
		this.isRejectProfileVerification = true;
		this.rejectSelectedProfileData = survey
	}

	// reject profile
	rejectProfileVerificationData = function (id) {
		
		this.authService.rejectProfileVerification(id).subscribe(data => {
			if (data.success) {
				
				this.authService.cancelProcess();
				this.getProfileVerificationReportList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/profile-verification-report-list/profile-verification-report-list.component.ts